// extracted by mini-css-extract-plugin
module.exports = {"placeholderButton":"styles__placeholderButton___3fNYh","placeholderImage":"styles__placeholderImage___3wKQs","videoWrapper":"styles__videoWrapper___XVO-r"};